"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = void 0;
const colors_1 = require("./colors");
const design_tokens_json_1 = __importDefault(require("./design-tokens.json"));
const helpers_1 = require("./helpers");
const { color: { primary, notification, greyscale } } = design_tokens_json_1.default;
const { font, spacing } = design_tokens_json_1.default;
exports.defaultTheme = {
    palette: {
        primary: (0, helpers_1.getColorValue)(primary['blue-danube']),
        primaryDarker: (0, helpers_1.getColorValue)(primary['blue-honolulu']),
        blueFrost: (0, helpers_1.getColorValue)(primary['blue-frost']),
        white: (0, helpers_1.getColorValue)(greyscale['white-snow']),
        platinumLighter: (0, helpers_1.getColorValue)(greyscale['grey-platinum-lighter']),
        platinum: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
        platinumDarker: (0, helpers_1.getColorValue)(greyscale['grey-platinum-darker']),
        cloud: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
        icicle: (0, helpers_1.getColorValue)(greyscale['white-icicle']),
        silver: (0, helpers_1.getColorValue)(greyscale['white-silver']),
        charcoal: (0, helpers_1.getColorValue)(greyscale['grey-charcoal']),
        border: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
        main: {
            background: (0, helpers_1.getColorValue)(greyscale['grey-platinum-darker']),
            contentBackground: (0, helpers_1.getColorValue)(greyscale['grey-platinum'])
        },
        texts: {
            black: (0, helpers_1.getColorValue)(greyscale['black-monument']),
            grey: (0, helpers_1.getColorValue)(greyscale['grey-steel']),
            lightgrey: (0, helpers_1.getColorValue)(greyscale['grey-chrome']),
            white: (0, helpers_1.getColorValue)(greyscale['white-silver']),
            disabled: (0, helpers_1.getColorValue)(greyscale['grey-platinum'])
        },
        icons: {
            white: (0, helpers_1.getColorValue)(greyscale['white-snow']),
            black: (0, helpers_1.getColorValue)(greyscale['black-monument']),
            disabled: (0, helpers_1.getColorValue)(greyscale['grey-platinum'])
        },
        header: {
            background: (0, helpers_1.getColorValue)(greyscale['black-onyx']),
            disconnected: (0, helpers_1.getColorValue)(notification['red-brick']),
            connected: (0, helpers_1.getColorValue)(notification['green-spruce']),
            dropdownBackground: (0, helpers_1.getColorValue)(greyscale['grey-granite']),
            dropdownBorderColor: (0, helpers_1.getColorValue)(greyscale['grey-steel']),
            shadow: '0px 2px 12px rgba(0,0,0,0.3)'
        },
        sidebar: {
            background: (0, helpers_1.getColorValue)(greyscale['black-oil'])
        },
        actionbar: {
            background: (0, helpers_1.getColorValue)(greyscale['black-monument'])
        },
        jumboHeader: {
            background: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
            title: (0, helpers_1.getColorValue)(greyscale['black-monument']),
            subtitle: (0, helpers_1.getColorValue)(greyscale['grey-smoke'])
        },
        accordion: {
            darkBackground: (0, helpers_1.getColorValue)(greyscale['black-obsidian']),
            whiteBackground: (0, helpers_1.getColorValue)(greyscale['white-snow']),
            shadow: `-1px 2px 7px ${(0, helpers_1.getColorValue)(greyscale['grey-cloud-45'])}`,
            darkShadow: `-2px 3px 10px ${(0, helpers_1.getColorValue)(greyscale['black-oil'])}`
        },
        card: {
            shadow: `-2px 3px 10px ${(0, helpers_1.getColorValue)(greyscale['grey-cloud-45'])}`,
            smallShadow: `-1px 2px 5px rgba(0,0,0,0.1)`,
            darkShadow: `-2px 3px 10px ${(0, helpers_1.getColorValue)(greyscale['black-oil'])}`
        },
        filterMenu: {
            background: (0, helpers_1.getColorValue)(greyscale['black-onyx']),
            badge: (0, helpers_1.getColorValue)(notification['red-indian'])
        },
        tabs: {
            background: (0, helpers_1.getColorValue)(greyscale['white-silver']),
            active: (0, helpers_1.getColorValue)(greyscale['white-snow']),
            hover: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
            activeHover: (0, helpers_1.getColorValue)(primary['blue-cerulean'])
        },
        select: {
            background: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
            border: (0, helpers_1.getColorValue)(greyscale['grey-chrome']),
            text: (0, helpers_1.getColorValue)(greyscale['grey-chrome'])
        },
        radioButton: {
            background: (0, helpers_1.getColorValue)(greyscale['white-snow']),
            checked: (0, helpers_1.getColorValue)(primary['blue-danube']),
            border: (0, helpers_1.getColorValue)(greyscale['black-onyx']),
            disabledBackground: (0, helpers_1.getColorValue)(greyscale['grey-chrome']),
            disabledChecked: (0, helpers_1.getColorValue)(greyscale['grey-cloud'])
        },
        checkbox: {
            background: (0, helpers_1.getColorValue)(greyscale['white-snow']),
            checked: (0, helpers_1.getColorValue)(primary['blue-danube']),
            border: (0, helpers_1.getColorValue)(greyscale['black-onyx']),
            disabledBackground: (0, helpers_1.getColorValue)(greyscale['grey-chrome']),
            disabledChecked: (0, helpers_1.getColorValue)(greyscale['grey-cloud'])
        },
        segmentedControl: {
            background: colors_1.colors.grey.joku,
            item: {
                background: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
                shadow: `1px 2px 4px ${(0, helpers_1.getColorValue)(greyscale['grey-cloud-45'])}`
            }
        },
        knob: {
            background: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
            checked: (0, helpers_1.getColorValue)(primary['blue-danube']),
            disabledBackground: (0, helpers_1.getColorValue)(greyscale['grey-chrome']),
            disabledChecked: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
            labelText: (0, helpers_1.getColorValue)(greyscale['grey-steel']),
            shadow: '0px 1px 4px inset rgba(0,0,0,0.1)'
        },
        modal: {
            header: {
                background: (0, helpers_1.getColorValue)(greyscale['grey-cloud'])
            },
            title: {
                primary: (0, helpers_1.getColorValue)(greyscale['grey-chrome'])
            },
            content: {
                background: (0, helpers_1.getColorValue)(greyscale['white-silver'])
            }
        },
        backgrounds: {
            buttons: {
                primary: (0, helpers_1.getColorValue)(primary['blue-danube']),
                dark: (0, helpers_1.getColorValue)(greyscale['grey-charcoal']),
                white: (0, helpers_1.getColorValue)(greyscale['white-snow']),
                disabled: (0, helpers_1.getColorValue)(greyscale['grey-smoke']),
                shadow: '1px 1px 2px rgba(0,0,0,0.15)',
                iconButtons: {
                    light: (0, helpers_1.getColorValue)(greyscale['grey-smoke']),
                    dark: (0, helpers_1.getColorValue)(greyscale['grey-charcoal']),
                    disabled: (0, helpers_1.getColorValue)(greyscale['grey-chrome']),
                    hover: (0, helpers_1.getColorValue)(greyscale['grey-steel']),
                    shadow: `0 2px 0 ${(0, helpers_1.getColorValue)(greyscale['grey-steel'])}`,
                    darkShadow: `0 2px 0 ${(0, helpers_1.getColorValue)(greyscale['black-oil'])}`
                },
                ripple: (0, helpers_1.getColorValue)(greyscale['grey-cloud'])
            },
            notifications: {
                success: {
                    background: (0, helpers_1.getColorValue)(notification['green-moss']),
                    iconBackground: (0, helpers_1.getColorValue)(notification['green-seafoam'])
                },
                info: {
                    background: (0, helpers_1.getColorValue)(notification['blue-azure']),
                    iconBackground: (0, helpers_1.getColorValue)(notification['blue-sky'])
                },
                warning: {
                    background: (0, helpers_1.getColorValue)(notification['yellow-ochra']),
                    iconBackground: (0, helpers_1.getColorValue)(notification['yellow-canary'])
                },
                error: {
                    background: (0, helpers_1.getColorValue)(notification['red-brick']),
                    iconBackground: (0, helpers_1.getColorValue)(notification['red-indian'])
                }
            }
        },
        editor: {
            header: {
                background: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
                title: (0, helpers_1.getColorValue)(greyscale['grey-chrome'])
            },
            subtitle: (0, helpers_1.getColorValue)(greyscale['grey-smoke'])
        },
        navigation: {
            primary: (0, helpers_1.getColorValue)(greyscale['black-onyx']),
            activeColor: (0, helpers_1.getColorValue)(primary['blue-electric']),
            backgroundGrey: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
            borderGrey: (0, helpers_1.getColorValue)(greyscale['grey-smoke'])
        },
        error: (0, helpers_1.getColorValue)(notification['red-brick']),
        defaultBorder: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
        primaryBorder: (0, helpers_1.getColorValue)(primary['blue-danube']),
        slider: {
            light: (0, helpers_1.getColorValue)(primary['blue-electric']),
            dark: (0, helpers_1.getColorValue)(primary['blue-cerulean']),
            disabledDark: (0, helpers_1.getColorValue)(greyscale['grey-chrome']),
            disabledLight: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
            outline: 'rgba(106, 183, 226, 0.4)'
        },
        indicators: {
            black: (0, helpers_1.getColorValue)(greyscale['grey-charcoal']),
            green: (0, helpers_1.getColorValue)(notification['green-moss']),
            yellow: (0, helpers_1.getColorValue)(notification['yellow-ochra']),
            red: (0, helpers_1.getColorValue)(notification['red-brick']),
            blue: (0, helpers_1.getColorValue)(notification['blue-azure'])
        },
        skeletons: {
            header: {
                color: (0, helpers_1.getColorValue)(greyscale['black-ebony']),
                highlightColor: (0, helpers_1.getColorValue)(greyscale['black-monument'])
            },
            editor: {
                color: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
                highlightColor: (0, helpers_1.getColorValue)(greyscale['white-silver'])
            },
            chart: {
                color: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
                highlightColor: (0, helpers_1.getColorValue)(greyscale['white-silver'])
            }
        },
        table: {
            border: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
            header: {
                background: (0, helpers_1.getColorValue)(greyscale['white-snow']),
                border: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
                sortIcon: (0, helpers_1.getColorValue)(greyscale['grey-smoke'])
            },
            row: {
                default: (0, helpers_1.getColorValue)(greyscale['white-snow']),
                even: (0, helpers_1.getColorValue)(greyscale['white-silver']),
                active: (0, helpers_1.getColorValue)(primary['blue-frost']),
                border: (0, helpers_1.getColorValue)(greyscale['grey-platinum']),
                hover: (0, helpers_1.getColorValue)(greyscale['grey-platinum'])
            },
            cell: {
                active: (0, helpers_1.getColorValue)(primary['blue-frost'])
            },
            truck: {
                light: (0, helpers_1.getColorValue)(primary['blue-electric'])
            }
        },
        input: {
            background: colors_1.colors.grey.snow,
            darkBackground: (0, helpers_1.getColorValue)(greyscale['black-onyx']),
            text: (0, helpers_1.getColorValue)(greyscale['black-obsidian']),
            darkText: (0, helpers_1.getColorValue)(greyscale['white-silver']),
            border: (0, helpers_1.getColorValue)(greyscale['grey-cloud']),
            shadow: '0px 2px 3px rgba(0, 0, 0, 0.05)',
            darkShadow: '-2px 3px 10px inset rgba(45, 45, 45, 0.40)'
        },
        link: (0, helpers_1.getColorValue)(primary['blue-cerulean']),
        charts: {
            nonSelected: colors_1.colors.grey.smoke,
            default: colors_1.cubehelix,
            baseColor: colors_1.colors.blue.clear,
            gradient: colors_1.colors.blue.clearTransparent,
            gridLineColor: 'rgba(0, 0, 0, 0.03)',
            yAxis: {
                labelColor: colors_1.colors.grey.smoke
            },
            xAxis: {
                labelColor: colors_1.colors.grey.chrome
            },
            compareColors: {
                first: colors_1.colors.blue.cobalt,
                second: colors_1.colors.red.canary,
                third: colors_1.colors.purple.pink,
                fourth: colors_1.colors.purple.windsor,
                fifth: colors_1.colors.red.ochra,
                sixth: colors_1.colors.green.seafoam
            }
        }
    },
    fonts: {
        families: {
            titleLight: 'Roboto-Light',
            titleMedium: 'Roboto-Medium',
            title: 'Roboto',
            contentRegular: 'Lato',
            content: 'Lato'
        },
        sizes: {
            large: '20px',
            medium: '16px',
            small: '14px'
        },
        lineHeights: {
            xLarge: 25,
            large: 21,
            medium: 20,
            small: 17
        },
        fonts: {
            h1: (0, helpers_1.mapFontStyles)(font.font.h1),
            h2: (0, helpers_1.mapFontStyles)(font.font.h2),
            h3: (0, helpers_1.mapFontStyles)(font.font.h3),
            h4: (0, helpers_1.mapFontStyles)(font.font.h4),
            p1: (0, helpers_1.mapFontStyles)(font.font.p1),
            p2: (0, helpers_1.mapFontStyles)(font.font.p2)
        }
    },
    spacings: {
        xxs: (0, helpers_1.mapSpacings)(spacing.xxs),
        xs: (0, helpers_1.mapSpacings)(spacing.xs),
        sm: (0, helpers_1.mapSpacings)(spacing.sm),
        base: (0, helpers_1.mapSpacings)(spacing.base),
        lg: (0, helpers_1.mapSpacings)(spacing.lg),
        xl: (0, helpers_1.mapSpacings)(spacing.xl),
        '2xl': (0, helpers_1.mapSpacings)(spacing['2xl']),
        '3xl': (0, helpers_1.mapSpacings)(spacing['3xl']) // 50
    }
};
